/* src/app/user-manage/user-manage.component.css */
.panel {
  width: 300px;
  margin-top: 15px;
  margin-bottom: 0px;
  margin-left: 20px;
}
.panel-body {
  padding: 7px;
}
.inc-top {
  margin-top: 10px;
}
.form-btn {
  margin-bottom: 30px;
  margin-top: 20px;
}
.radio input[type=radio] {
  margin-right: 8px;
}
/*# sourceMappingURL=user-manage.component.css.map */
